module.exports = __webpack_public_path__ + "static/media/top_right.8dc9643f.png";